import React from 'react'
import { Box, Icon, H2, H4, H6 } from '@maui/elements'
import { useIndicatorFetch } from '@nautilusjs/mati-apis'
import { MScoreDetails } from '../../common'
import { CopyButton } from './common'
import { WidgetLoading } from '../../common/WidgetLoading'

export const IndicatorSearchPreview = ({ data }) => {
  const {
    type,
    value,
    associated_hashes: associatedHashes = []
  } = data
  const { data: indicator, isFetching } = useIndicatorFetch({ type, value })
  return (
    <Box>
      <Box display='flex' gap='12px'>
        <Box>
          <Icon name='fingerprint' verticalAlign='-12.4px'/>
        </Box>
        <H2
          m={0}
          width='100%'
          textOverflow='ellipsis'
          overflow='hidden'
          whiteSpace='nowrap'
          textTransform={type?.match('sha1|sha256|md5') ? 'uppercase' : 'lowercase'}
        >
          {type?.match('sha1|sha256|md5') ? `FILE:${value}` : value }
        </H2>
      </Box>
      <Box>
        {isFetching && <WidgetLoading />}
        {indicator && (
          <Box>
            <MScoreDetails
              score={indicator?.mscore}
              verdict={indicator?.verdict}
              variant='stacked'
              marginBottom="1rem"
              summaryOnly={true}
            />
            <Box>
              { !!associatedHashes.length &&
                <Box>
                  <H4 m={0} mb='4px'>File Information</H4>
                  <Box height='1px' backgroundColor='colorBorderDeemphasis'/>
                </Box>
              }
              <Box mt='8px'>
                {associatedHashes.map((associatedHash, index) => (
                  <Box key={index} display='flex' mb='4px'>
                    <H6 width='80px'm={0} color='colorTextDeemphasis'>{associatedHash.type?.toUpperCase()}</H6>
                    <H6 width='100%' overflow='hidden' whiteSpace='nowrap' color='colorTextMain' m='0' textOverflow='ellipsis'>{associatedHash.value}</H6>
                    <Box marginLeft='8px'>
                      <CopyButton value={associatedHash.value} />
                    </Box>
                  </Box>
                )).reverse()}
              </Box>
            </Box>
          </Box>
        )
        }
      </Box>
    </Box>
  )
}
